import { actionCandidateStatusOptions } from 'modules/analyse/constants/actionCadidateStatusOptions';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const getAvailableActions = (values: AutomationFormItem[]) => {
  const actions = values.map((item) => item.action);
  const candidateStatusesUsed = actions
    .map((action) => action.candidateStatus)
    .filter(Boolean);
  const candidateStatuses = actionCandidateStatusOptions.filter(
    (status) => !candidateStatusesUsed.includes(status)
  );
  return { candidateStatusesAvailableOptions: candidateStatuses };
};
